<template>
  <Card :name="config.variableFullName">
    <template v-slot:header >
      <h5 class="card-category pull-right">{{getTimeAgo((nowTime - time) / 1000)}} ago </h5>
      <h4 class="card-title">
        {{ config.variableFullName }} <a v-if="maps_link != '' " target="_blank" :href="maps_link"> -> Maps ( {{m.position[0]}} , {{m.position[1]}} ) </a> 
      </h4>
      <button
              class="btn btn-info pull-left"
              @click="changeSize()"
              > {{this.size}}
      </button>   
    </template>
  <div id="map-wrap" :style="height" >
        
      <l-map :zoom="m.zoom" :center="m.center">      
      <l-circle-marker :lat-lng="m.my_position"  v-if="my_position"  />
      <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
      <l-marker type="click" :target="getLatLng" :lat-lng="m.position" v-if="position==true"  ></l-marker>
     
      <l-control-scale />
      
      </l-map>
  </div>

</Card>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LCircleMarker,LMarker,LControlScale } from "@vue-leaflet/vue-leaflet"
import emitter from '@/eventBus';
export default {
  props: ['config'],
  name:"openStreetLocation",
  components:{
    LMap,
    LTileLayer,
    LCircleMarker,
    LMarker,
    LControlScale
  },
  data() {
    return {
      maps_link : "",
      nowTime: Date.now(),
      time: Date.now(),
      size: "grande",
      height:"height: 50vh" ,
      my_position: false,
      position: false,
      m : {
        my_position: [0,0],
        position : [0,0],
        center: [0,0],
        marker: [0,0],
        zoom:5

      },
     

      topic: "",
    };
  },
  watch:  {
            config: {
                immediate: true,
                deep: true,
                handler() {
                    setTimeout(() => {
                        emitter.off(this.topic + "/sdata");
                        let variable = this.config.variable;  
                        if (this.$store.state.selectedDevice.ext_mqtt){
                          variable = this.config.variableFullName 
                        }
                        //userId/dId/uniquestr/sdata
                        this.topic = this.config.userId + "/" + this.config.selectedDevice.dId + "/" + variable;
                        emitter.on(this.topic + "/sdata", this.processReceivedData);
                        //  console.log(topic)
                
                    }, 300);
                }
            }
        },
  mounted(){
    this.getNow();
    if (this.config.demo) {
      this.height = "height: 40vh"
      }
    this.geolocate()
    
  },
  beforeDestroy(){
    emitter.off(this.topic + "/sdata");
  },
  methods: {

    getLatLng(position)	{
      return position
    },

    changeSize () {
      if (this.height == "height: 75vh") {
        this.height = "height: 50vh"
        this.size = "Grande"
      } else {
        this.height = "height: 75vh"
        this.size = "Pequeño"
      }
    },


    geolocate() {
      navigator.geolocation.getCurrentPosition(position => {
        // console.log(position)
        const my_position = [position.coords.latitude, position.coords.longitude]
        this.m.center = my_position
        this.m.my_position = my_position
        this.marker = my_position
        this.m.zoom = 12
        this.my_position = true        
      });
      return this.m.center

    },

    processReceivedData(data){
      try {
        //console.log("received");
        //console.log(data);
        const {value} = data
        this.time = Date.now()
        this.m.position = value
        this.m.center = value
        this.m.zoom = 12
        this.maps_link =  `https://maps.google.com/?q=${value[0]},${value[1]}`
        this.position = true
      } catch (error) {
        console.log(error);
      }
    },

     getTimeAgo(seconds) {

                if (seconds < 0) {
                    seconds = 0;
                }

                if (seconds < 59) {
                    return seconds.toFixed() + " secs";
                }

                if (seconds > 59 && seconds <= 3600) {
                    seconds = seconds / 60;
                    return seconds.toFixed() + " min";
                }

                if (seconds > 3600 && seconds <= 86400) {
                    seconds = seconds / 3600;
                    return seconds.toFixed() + " hour";
                }

                if (seconds > 86400) {
                    seconds = seconds / 86400;
                    return seconds.toFixed() + " day";
                }


            },

            getNow() {
                this.nowTime = Date.now();
                setTimeout(() => {
                    this.getNow();
                }, 1000);
            },

    
  }
};


</script>

    